'use strict';

var React = require('react');
var BasicInfo = require('./BasicInfo-DwD6dQA0.js');
var Text = require('@swiggy-private/dls-web-core/dist/components/Text');
var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const Header$1 = styled__default.default.div(({ theme, hideBorder }) => (Object.assign({ borderBottom: `1px solid ${theme.colors[theme.colorMode].border_Secondary}`, margin: `${theme.spacing.xxLarge} ${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.medium}` }, (hideBorder && {
    borderBottom: "none",
    marginBottom: 0,
}))));
const HeaderText = styled__default.default(Text.Text)(({ theme }) => ({
    marginBottom: theme.spacing.small,
    marginTop: theme.spacing.xxSmall,
}));

const CustomizeHeader = (props) => {
    const { itemData, currentStep } = props;
    return (React__default.default.createElement(Header$1, { hideBorder: currentStep >= 2 },
        React__default.default.createElement(BasicInfo.BasicItemInfo, { itemData: itemData }),
        React__default.default.createElement(HeaderText, { variant: "V2.heading2.neutral.black", color: "text_High_Emphasis" }, "Customise as per your taste")));
};
var Header = React__default.default.memo(CustomizeHeader);

exports.Header = Header;
//# sourceMappingURL=Header-wk4mHKME.js.map
